import { Controller } from "@hotwired/stimulus";

// The ACH review-and-authorize step of the collection invoice Pay modal.
//
// Authorize stays disabled until the terms checkbox is checked and the typed
// signature matches the signed-in user's full name, ignoring case and extra
// spaces. A user without a first and last name on file gets no checkbox or
// signature field, so Authorize stays disabled. Authorizing only shows a
// placeholder for now: no request is sent.
//
// The check instructions toggle swaps the ACH details (everything after the
// amount, through Authorize) for the program’s check payment instructions, and back.
export default class extends Controller {
  static targets = [
    "checkbox", "signature", "submitButton", "placeholder",
    "achDetails", "checkInstructions", "checkPrompt", "achPrompt"
  ];
  static values = { expectedName: String, brandLinkColor: String };

  connect() {
    // The layout colors links with the program's secondary brand color; the
    // toggle buttons styled as links pick it up through this variable.
    if (this.brandLinkColorValue) {
      this.element.style.setProperty("--brand-link-color", this.brandLinkColorValue);
    }

    // Without a bank account there's nothing to authorize.
    if (this.hasSubmitButtonTarget) this.validate();
  }

  validate() {
    if (!this.hasSignatureTarget) return;

    const expected = this.normalize(this.expectedNameValue);
    const signed = this.normalize(this.signatureTarget.value);
    this.submitButtonTarget.disabled = !(this.checkboxTarget.checked && expected !== "" && signed === expected);
  }

  authorize(event) {
    event.preventDefault();
    this.placeholderTarget.hidden = false;
  }

  toggleCheckInstructions() {
    const showCheck = this.checkInstructionsTarget.hidden;
    this.achDetailsTargets.forEach(element => { element.hidden = showCheck; });
    this.checkInstructionsTarget.hidden = !showCheck;
    this.checkPromptTarget.hidden = showCheck;
    this.achPromptTarget.hidden = !showCheck;

    // Keep keyboard focus on the toggle, which is now the other prompt's button.
    const prompt = showCheck ? this.achPromptTarget : this.checkPromptTarget;
    prompt.querySelector("button").focus();
  }

  normalize(name) {
    return name.trim().replace(/\s+/g, " ").toLowerCase();
  }
}
